<template>
    <v-menu
        ref="calendar"
        v-model="calendar.popup"
        :close-on-content-click="false"
        offset-y
        max-width="290px"
        offset-overflow
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                v-on="on"
                :label="$t(label)"
                :value="calendarDates"
                readonly

                clearable
                @click:clear="filterByCalendarDatesReset(model)"

                :prepend-inner-icon="isSortable ? 'arrow_upward' : null"
                @click:prepend-inner="$emit('sort')"

                hide-details
                :full-width="!standardStyle" :background-color="standardStyle ? 'transparent' : 'grey lighten-4'"
                :style="{ minWidth: width, maxWidth: width }"
            ></v-text-field>
        </template>
        <v-date-picker :value="calendar.dates" @input="onCalendarChange" :max="max" multiple no-title scrollable>
            <v-layout wrap>
                <v-flex>{{ $attrs }}</v-flex>
                <v-flex xs12 px-3 pb-3>{{ $t('Click to set start date; optionally click again to also set end date') }}</v-flex>

                <v-flex xs12 layout justify-space-between>
                    <v-btn flat color="primary" @click="calendar.popup = false">{{ $t('Close') }}</v-btn>
                    <v-btn flat color="success" @click="filterByCalendarDates(model)"><v-icon left>done</v-icon>{{ $t('Apply') }}</v-btn>
                </v-flex>
            </v-layout>
        </v-date-picker>
    </v-menu>
</template>

<script>
export default {
    name: 'v-input-date-range-picker',
    props: {
        value: {
            type: Object
        },
        label: {
            type: String,
            default: 'Date'
        },
        max: {
            type: String,
            default: new Date().toISOString().slice(0, 10)
        },
        standardStyle: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            model: {
                start_date: undefined,
                end_date: undefined
            },
            calendar: {
                popup: false,
                dates: []
            },
        }
    },
    computed: {
        isSortable() {
            return !!this.$listeners.sort;
        },
        calendarDates() {
            return this.calendar.dates.join(' ~ ');
        },
        width() {
            return (this.model && this.model.end_date ? 19 : 12) + 'rem';
        }
    },
    mounted() {
        // console.log('Mounted, value', JSON.stringify(this.value));
        this.init();
    },
    watch: {
        value() {
            // console.log('Value changed outside', this.value);
            this.init();
        },
        'calendar.popup'() {
            if (!this.calendar.popup) {
                this.init();
            }
        }
    },
    methods: {
        text(evt) {
            console.log('Text event', evt);
        },
        init() {
            this.model = this.value;
            this.calendar.dates = [];
            if (this.value && this.value.start_date) {
                this.calendar.dates.push(this.value.start_date);
                if (this.value.end_date) {
                    this.calendar.dates.push(this.value.end_date);
                }
            }
        },

        /** @param {array} vals `vals = ['2023-07-20', '2023-07-21']` - array of date_iso_string - in chronological order of user selection (last item is currently selected) */
        onCalendarChange(vals) {
            const curval = vals[vals.length - 1];// current val is last one
            const index = this.calendar.dates.findIndex(val => val === curval);
            if (index >= 0) {// if already exists - remove it from calendar.dates[]
                this.calendar.dates.splice(index, 1);
            }
            else {// if new - add to calendar.dates[]
                this.calendar.dates.push(curval);
            }

            if (vals.length > 2) {
                this.calendar.dates.splice(0, 1);
            }
        },

        filterByCalendarDates(model) {
            const cd0 = this.calendar.dates[0];
            const cd1 = this.calendar.dates[1];
            if (cd1 && cd1 < cd0) {// if date2 not-after date1 - swap
                this.calendar.dates[0] = cd1;
                this.calendar.dates[1] = cd0;
            }

            model = {
                start_date: this.calendar.dates[0],
                end_date: this.calendar.dates[1]
            };
            this.calendar.popup = false;
            this.$emit('input', model);
        },
        filterByCalendarDatesReset(model) {
            model = {
                start_date: undefined,
                end_date: undefined
            };
            this.$emit('input', model);
        }
    }
}
</script>
